import script from "./sensitive-outbound-events.vue?vue&type=script&setup=true&lang=ts"
export * from "./sensitive-outbound-events.vue?vue&type=script&setup=true&lang=ts"

import "./sensitive-outbound-events.vue?vue&type=style&index=0&id=6a19b334&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a19b334"]])

export default __exports__